module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-06-40dc5c62605dcd06092922081a7c49ce.png";